module.exports = "<div fxLayout class=\"soon blue-gradient row-padding banner\" fxLayoutAlign=\"center center\">\r\n  <div fxFlex fxLayout=\"column\" class=\"text-center\">\r\n    <h1 class=\"jumbo mb0\">{{ 'SOON.HEADER' | translate }}</h1>\r\n    <div class=\"row-padding\">\r\n      <button [routerLink]=\"['']\" class=\"btn light\">{{ 'SOON.ACTION' | translate }}</button>\r\n    </div>\r\n    <div class=\"row-padding\">\r\n      <img src=\"../../assets/logo-white.png\" alt=\"\">\r\n    </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/soon/soon.component.html
// module id = 379
// module chunks = 1